//Libraries
import React from 'react';
import { connect } from 'react-redux';
//Actions
import { removeClan } from '../actions/clans';
//Components
import AlertModal from 'locki-dashboard-navigation/dist/alertModal';
//Material-ui
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';

class SimpleMenu extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      anchorEl: null,
      alertModal: false
    };
  }
  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  handleEdit = () => {
    const { clan, callback } = this.props;
    callback(clan);
    this.handleClose();
  };
  handleRemove = () => {
    const { id } = this.props;
    this.props.removeClan(id);
    this.handleClose();
    this.toggleAlertModal();
  };
  toggleAlertModal = () => {
    this.setState(prevState => ({
      alertModal: !prevState.alertModal
    }));
  };
  render() {
    const { anchorEl, alertModal } = this.state;
    const { clan } = this.props;
    return (
      <div>
        <AlertModal
          action={this.handleRemove}
          closeModal={this.toggleAlertModal}
          header={`¿Quieres eliminar a la familia ${clan.name}?`}
          open={alertModal}
          subh={"Al eliminar una familia, esta se borra de forma permanente. Esta operación no puede ser anulada."}
        />
        <IconButton
          aria-label="More"
          aria-owns={open ? 'long-menu' : null}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <MenuItem onClick={this.handleEdit}>Editar</MenuItem>
          <MenuItem onClick={this.toggleAlertModal}>Eliminar</MenuItem>
        </Menu>
      </div>
    );
  }
}

const mapStateToProps = (state, {id}) => ({
  clan: state.clans.data.find((element) => element.id === id)
});

const mapDispatchToProps = (dispatch) => ({
  removeClan: (clanUid) => dispatch(removeClan(clanUid))
});

export default connect(mapStateToProps, mapDispatchToProps)(SimpleMenu);
